// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

/** Indonesia */
const ID: PhoneNumberData = [62, 'ID', 12, '000-0000-00000'];

export default ID;
